import Container from "react-bootstrap/Container";
import Education from "../components/Education";
import Background from "../components/Background";
import Skills from "../components/Skills";

function About(props) {
  return (
    <>
      <Container>
        <Background />
        <Education />
        <Skills />
      </Container>
    </>
  );
}

export default About;
